import * as React from 'react';
import { useSelector } from 'react-redux';

import { offerSelector } from 'shared/selectors';
import { selectNewbuildingFromDeveloperUrl } from 'shared/selectors/newObject';
import { IState } from 'shared/store';
import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getJsonQuery } from './utils';
import { useSaveSearchContext } from '../../../packages/SaveSearchModal';

export function useSearchSetParams() {
  const { onOpen, setParams } = useSaveSearchContext();

  const offer = useSelector<IState, IOfferSchema>(offerSelector);
  const defaultTitle = React.useMemo(() => offer.geo.address.map(a => a.shortName).join(', '), [offer.geo.address]);
  const jsonQuery = React.useMemo(() => getJsonQuery(offer), [offer]);
  const queryString = useSelector(selectNewbuildingFromDeveloperUrl);

  const handleClick = React.useCallback(() => {
    const additionalParams = {
      title: defaultTitle,
      modalTitle: 'Добавить дом в избранное',
      submitButtonText: 'Добавить дом в избранное',
      jsonQuery,
      analyticsParams: {
        pageType: 'Card',
        queryString,
        offerId: offer.id,
        isFromBanner: false,
      },
    };

    setParams(additionalParams);

    onOpen();
  }, [defaultTitle, jsonQuery, offer.id, queryString, onOpen, setParams]);

  return handleClick;
}
